(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('ClientListController', ClientListController);

    ClientListController.$inject = ['$scope', 'Principal','$state','ClientListService','$location','$timeout','$window', 'PortfolioTrackerService','$http'];

    function ClientListController($scope, Principal, $state,ClientListService,$location,$timeout,$window,PortfolioTrackerService,$http) {
    	var gridData='';
    	$scope.clientNameList = [];
    	$scope.rissProductNameList=[];
    	$scope.productNameModel=[];
    	$scope.selectedclientNameTemp = [];
    	$scope.selectedProductNameTemp = [];
		$scope.clientModel = [];
    	$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.porttoDate = '';
		$scope.portfromDate = '';
		$scope.graceDateForm = '';
		$scope.isTrialSubscription = "";
		
		$scope.isTrailSubflag = false;

		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];
		
		$scope.format = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];
		
		$scope.$watch('fromDate', function() {

			if (!$scope.fromDate) {
				return;
			}
			if (!$scope.startMaxDate || $scope.startMaxDate > $scope.fromDate) {
				$scope.endMaxDate = new Date();
			} else {
				$scope.startMaxDate = $scope.fromDate;
			}
			$scope.fromDate = $scope.fromDate;

		});

		$scope.$watch('misReport.toDate', function() {

			if (!$scope.toDate) {
				return;
			}
			if (!$scope.endMaxDate || ($scope.endMaxDate > $scope.fromDate)) {
				// $scope.endMaxDate = $scope.misReport.toDate;
			} else {
				$scope.startMaxDate = $scope.toDate;
			}
			$scope.toDate = $scope.toDate;
		});
		
		$scope.checkSubscriptiondateErr = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;

			var curDate = new Date();

			if (fromDate != '' && toDate != '') {
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					alert("todate should be greater than fromDate.");
					return false;
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("fromDate should not be before today.");
					return false;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
		};

		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.popup5 = {
				opened : false
			};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};
		$scope.open5 = function($event) {
			$scope.popup5.opened = true;
		};
   
/*         $scope.getClientListData = function(){
        	 ClientListService.getClientList().then(function(data) {
        		
        		 $scope.gridData = {
  						dataProvider: data,
  		                   delegate: $scope

  		               };	
 			}, function(errordata) {
 				console.log("Some thing went wrong!");
 			});
         }*/

   	   $scope.clientListGridCompletion = function (event) {
    		  gridData = event.target;
    		  gridData.validateNow();
         }; 

         
         $scope.getHrefData = function(item,column){        	 
        	 return ('<div><a href="" onClick="redirectToClientDetails(this)" id='+item.clientCode+'>'+item.clientName+'</a></div>');
        		 
         }

         $scope.redirectToClientDetails=function(clientCode){ 
        	 $timeout(
        				function() {
        					//$location.path('clientDetails/'+clientCode);
        					$state.go('clientDetails',{'clientCode':clientCode});
        				}, 10);
        	 
        }
        
         $window.redirectToClientDetails= function(item) {
             
             var clientCode = item.id;
             $scope.redirectToClientDetails(clientCode)
}
 		$scope.getClientNameList = function() {

			PortfolioTrackerService.getClientList().then(function(data) {
				$scope.clientNameList = data;
			}, function(errordata) {
				
			});

		}
 		
 		$scope.getRissProductName = function() {

 			ClientListService.getRissProductNameList().then(function(data) {
				$scope.rissProductNameList = data;
			}, function(errordata) {
				
			});

		}
 		
 		

 		$scope.getClientDetails = function(){
		
		$scope.checkSubscriptiondateErr($scope.portfromDate, $scope.porttoDate);
		if ($scope.fromDateTrue == true && $scope.toDateTrue == true) {
			$scope.toDateData = $scope.porttoDate;
			$scope.fromDateData = $scope.portfromDate;
		} else {
			$scope.toDateData = '';
			$scope.fromDateData = '';
		}

		if ($scope.fromDateData == undefined) {
			$scope.fromDateData = '';
		}

		if ($scope.toDateData == undefined) {
			$scope.toDateData = '';

		}

		// client name

		if ($scope.clientModel != undefined) {
			$scope.selectedclientNameTemp = $scope.clientModel.map(function(
					element) {
				return "<" + String(element.labelName) + "<"
			})
		}
		
		if ($scope.productNameModel != undefined) {
			$scope.selectedProductNameTemp = $scope.productNameModel.map(function(
					element) {
				return "<" + String(element.labelName) + "<"
			})
		}
		
		if(($scope.isTrialSubscription.toLowerCase() == 'y' | $scope.isTrialSubscription.toLowerCase() == 'n')){
			$scope.isTrailSubflag = false;
		}else if($scope.isTrialSubscription == ""){
			$scope.isTrailSubflag = false;
		}else{
			$scope.isTrailSubflag = true;
			$scope.isTrailSubErrorMessage = 'Please type either Y or N';
		}

		var searchText = '';
		searchText = "{'fromDate' : '" + $scope.fromDateData
				+ "', 'toDate' : '" + $scope.toDateData
				+ "', 'graceDate' : '" + $scope.graceDateForm
				+ "', 'productName' : '" + $scope.selectedProductNameTemp
				+ "', 'isTrailSubscription' : '" + $scope.isTrialSubscription.toLowerCase()
				+ "','clientName':'" + $scope.selectedclientNameTemp + "'}";
		searchText = searchText.replace(/\'/g, "\"");
		searchText = searchText.replace(/\</g, "\'");
		$scope.finalFilterData = searchText
		ClientListService.getClientList(searchText)
		.then(
				function(result) {
					$scope.gridData = {
							dataProvider : result,
							delegate : $scope
						};
				});
		
    }
 		
		$scope.exportExcelClientList = function() {

			$http({
				url : 'api/clientList/getClientListExcelExport',
				method : 'POST',
				data : $scope.finalFilterData,
				responseType : 'arraybuffer'
			})
					.success(

							function(response) {

								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var blob = new Blob(
										[ response ],
										{
											type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
										});
								if (isIE) {

									window.navigator.msSaveOrOpenBlob(blob,
											'Clinet List.xlsx');
								} else {

									var anchor = angular.element('<a/>');
									var blob = new Blob([ response ], {
										type : 'application/vnd.ms-excel'
									})
									var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
									anchor.css({
										display : 'none'
									});
									// Make sure it's not visible
									angular.element(document.body).append(
											anchor); // Attach to document
									anchor.attr({
										href : objectUrl,
										target : '_self',

										download : 'Client List.xlsx'
									})[0].click();

									anchor.remove();

								}

							})

		}
		$scope.showHideFilter = false;
		$scope.filterCriteriaFlag = {
                showHideVar: true
            }
		$scope.showResult = {
                showHideResult: false
            }
		
		$scope.openInputFilterContainer = function(){
			 if ($scope.filterCriteriaFlag.showHideVar) {
				 $scope.showHideFilter = true;
			$scope.filterCriteriaFlag = {
	                    showHideVar: false
	                }
			$scope.showResult = {
	                    showHideResult: true
	                }
			 }else {
				 $scope.showHideFilter = false;
	                $scope.filterCriteriaFlag = {
	                    showHideVar: true
	                }
	           
	                $scope.showResult = {
	                    showHideResult: true
	                }
	              
	                // $scope.showUnlisted = false ;
	                // $scope.showNoteForDataNotFoundYear = false;
	            }
		}
 		
 		
 		$scope.getRissProductName();
 		
 		$scope.restFilter = function(){
 			$scope.selectedclientNameTemp = [];
 	    	$scope.selectedProductNameTemp = [];
 			$scope.clientModel = [];
 	    	$scope.fromDate = new Date();
 			$scope.toDate = new Date();
 			$scope.porttoDate = '';
 			$scope.portfromDate = '';
 			$scope.graceDateForm = '';
 			$scope.isTrialSubscription = "";
 		   	$scope.productNameModel=[];
 			$scope.isTrailSubflag = false;
 			$scope.getClientDetails();
 		}
 		
 		$scope.getClientNameList();
 		
 		$scope.getClientDetails();
    }    

})();

